module.exports = __webpack_public_path__ + "static/media/insideout-logo-donker.548a1e06.svg";